"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var _get = _interopRequireDefault(require("lodash/get"));
var _BrixelTooltip = _interopRequireDefault(require("../BrixelTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelCheckbox = props => {
  const {
    cardLayout = false,
    cardSmall = false,
    className = '',
    classNameParent = '',
    disabled = false,
    icons = false,
    input = {
      name: ''
    },
    isHorizontal = false,
    label = null,
    large = false,
    limit = -1,
    message = {
      help: null,
      error: null
    },
    meta = {
      dirty: false,
      invalid: false
    },
    moreInfo,
    options = [],
    pdClass = '',
    showError = true,
    setValue = null,
    svgSupport = false,
    svgWidth = null,
    tooltip,
    validation = false
  } = props;
  // STATE
  const [arrVal, setArrVal] = (0, _react.useState)([]);
  const [showMoreInfo, setShowMoreInfo] = (0, _react.useState)({});
  const [onHoverImg, setOnHoverImg] = (0, _react.useState)([...Array(options.length)]);
  const [delayedOpenClass, setDelayedOpenClass] = (0, _react.useState)('');
  const [showErrorState, setShowErrorState] = (0, _react.useState)(showError);
  (0, _react.useEffect)(() => {
    const index = 0; // Or any other number
    const timeoutId = setTimeout(() => {
      if (showMoreInfo[index]) {
        setDelayedOpenClass('open');
      } else {
        setDelayedOpenClass('');
      }
    }, 1);
    return () => clearTimeout(timeoutId);
  }, [showMoreInfo]);
  (0, _react.useEffect)(() => setArrVal(input.value || []), [input.value]);
  const onChange = (_e, val = '') => {
    const value = (0, _cloneDeep.default)(arrVal) || [];
    if (value && typeof value === 'object') {
      const idValue = value.findIndex(item => item === val);
      if (idValue >= 0) value.splice(idValue, 1);else value.push(val);
      if (limit < 0 || value.length <= limit) {
        setArrVal([...value]);
        if (setValue) setValue(value);
        if (input.onChange && options.length > 0) input.onChange(value);
      }
    }
    setShowErrorState(false);
  };
  const hoverImg = (index, hover) => {
    const imgList = (0, _cloneDeep.default)(onHoverImg);
    imgList[index] = hover;
    setOnHoverImg(imgList);
  };
  const OptionsComponent = (item, i) => {
    const {
      value,
      color,
      icon,
      backIcon,
      img
    } = item;
    let classWrapElement = '';
    const optionLabel = (0, _get.default)(item, 'label', '');
    const optionMoreInfoExpand = (0, _get.default)(item, 'moreInfoExpand', '');
    if (isHorizontal && cardLayout) classWrapElement = 'ml-a mr-a mr-small-sm-12 ml-small-sm-12';else if (isHorizontal && !cardLayout) classWrapElement = 'mr-2';else if (options.length !== 1) classWrapElement = 'mb-2';
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: `${className} ${icons ? 'brixel-checkbox-icon dis-f' : 'brixel-checkbox dis-f'} ${cardLayout ? `${cardSmall ? 'cardSmall' : ''} w-perc-100` : ''} ${classWrapElement}`,
      key: `opt_${i}`,
      "data-testid": `singleCheckboxDiv${i}`,
      onMouseEnter: () => hoverImg(i, true),
      onMouseLeave: () => hoverImg(i, false)
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: `${disabled || limit > 0 && arrVal.length >= limit ? 'disabled' : ''} ${arrVal.includes(value) ? 'checked' : ''} ${pdClass} ${cardLayout && window.innerWidth < 590 ? 'dis-fl-col row-reverse' : ''} ${cardLayout && window.innerWidth >= 590 ? 'dis-fl-col col-reverse' : ''} ${color || ''} ${svgSupport && (onHoverImg[i] || arrVal.includes(value)) ? 'onHover' : ''} ${meta.dirty && meta.invalid && message.error && icons ? 'brdRed400 brdSmall' : ''} w-fit`,
      "data-testid": `singleCheckboxLabel${i}`,
      htmlFor: `${input.name}_${i}`
    }, /*#__PURE__*/_react.default.createElement("input", {
      "data-testid": `singleCheckbox${i}`,
      role: "checkbox",
      className: "notranslate",
      "data-validation": validation,
      disabled: disabled,
      type: "checkbox",
      id: `${input.name}_${i}`,
      value: value,
      name: input.name,
      checked: arrVal.includes(value),
      onChange: e => onChange(e, value)
    }), icons ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: `${cardLayout && window.innerWidth < 590 ? 'row-reverse jc-b' : ''} ${cardLayout && window.innerWidth >= 590 ? 'col-reverse jc-c' : ''} ${cardLayout ? 'dis-fl-col a-c w-perc-100' : 'dis-f a-c'}`
    }, icon && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      color: backIcon || 'primary',
      saturationTxt: 700,
      background: backIcon || 'primary',
      saturation: 200,
      icon: icon,
      className: "mr-1"
    })), cardLayout ? (/*#__PURE__*/_react.default.createElement("div", {
      className: `${svgWidth || `${cardSmall ? 'smallIcon' : ''}`} iconHolder`
    }, svgSupport ? (/*#__PURE__*/_react.default.createElement("div", {
      className: "svg-container",
      dangerouslySetInnerHTML: {
        __html: img || ''
      }
    })) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, img && (/*#__PURE__*/_react.default.createElement("img", {
      src: img,
      alt: optionLabel
    })))))) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, img && (/*#__PURE__*/_react.default.createElement("img", {
      className: "",
      src: img,
      alt: optionLabel
    })))), /*#__PURE__*/_react.default.createElement("span", {
      className: `textLabel ${large ? 'labelLarge' : ''} ${cardLayout ? 'a-c ta-c-sm' : ''} ${cardLayout && window.innerWidth >= 590 ? 'pt-2 pb-4' : 'pl-2'} pl-1 pl-md-0`,
      dangerouslySetInnerHTML: {
        __html: optionLabel
      }
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "checkmark"
    }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      color: "white",
      icon: "check",
      className: "pl-small-1"
    })))) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "checkmark"
    }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      color: "white",
      icon: "check",
      className: "pl-small-1"
    })), /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: optionLabel
      }
    }))))), optionMoreInfoExpand && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      className: "dis-b mt-1-neg ml-1",
      icon: showMoreInfo[i] ? 'arrow-simple-up' : 'arrow-simple-down',
      onClick: () => setShowMoreInfo({
        ...showMoreInfo,
        [i]: !showMoreInfo[i]
      })
    }))), showMoreInfo[i] && (/*#__PURE__*/_react.default.createElement("div", {
      className: `moreInfo ${delayedOpenClass}`
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      className: 'p-2 bgText25 brdRadius mt-1 mb-2',
      dangerouslySetInnerHTML: {
        __html: optionMoreInfoExpand
      }
    })))));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-checkbox-wrapper ${meta.dirty && meta.invalid ? 'required-state' : ''} ${(message.help || meta.invalid) && showErrorState ? 'checkbox-error' : ''}`
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    className: "brixel-label",
    "data-testid": "label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, label), tooltip && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: `${cardLayout ? 'cardLayout jc-c' : ''} ${cardSmall ? 'cardSmall' : ''} ${isHorizontal ? 'dis-fl-row' : 'dis-fl-col'} ${classNameParent} ${cardLayout && window.innerWidth < 590 ? 'flex-wrap' : ''}`
  }, options.map((val, i) => (/*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `optCmp_${i.toString()}`
  }, OptionsComponent(val, i))))), (message.help || meta.invalid) && showErrorState && (/*#__PURE__*/_react.default.createElement("span", {
    className: `message ${cardLayout ? 'cardError' : ''} ${meta.dirty && meta.invalid ? 'error-message' : ''}`
  }, meta.dirty && meta.invalid ? message.error : message.help)), moreInfo && !meta.dirty && !meta.invalid && (/*#__PURE__*/_react.default.createElement("p", {
    className: moreInfo.className
  }, moreInfo.message)));
};
var _default = exports.default = BrixelCheckbox;